import PropTypes from 'prop-types';
// @mui
import { Button, IconButton, Link, Stack, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
// components
import Iconify from './Iconify';
// utils
import { SOCIAL_SPOREXPERT } from '../utils/social';

// ----------------------------------------------------------------------

SocialsButton.propTypes = {
  initialColor: PropTypes.bool,
  simple: PropTypes.bool,
  sx: PropTypes.object,
};

export default function SocialsButton({ initialColor = false, simple = true, sx, ...other }) {

  return (
    <Stack direction="row" flexWrap="wrap" alignItems="center">
      {SOCIAL_SPOREXPERT.map((social) => {
        const { name, icon, href, socialColor } = social;
        return simple ? (
          <Link key={name} href={href}>
            <Tooltip title={name} placement="top">
              <IconButton
                color="inherit"
                sx={{
                  ...(initialColor && {
                    color: socialColor,
                    '&:hover': {
                      bgcolor: alpha(socialColor, 0.08),
                    },
                  }),
                  ...sx,
                }}
                {...other}
              >
                <Iconify icon={icon} sx={{ width: 20, height: 20 }} />
              </IconButton>
            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            href={href}
            color="inherit"
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              flexShrink: 0,
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha(socialColor, 0.08),
                },
              }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
